import { cn } from '@listening/utils/react-helpers';
import IconClose from '@listening/assets/astro/icons/icon-close.svg?react';
import IconMenu from '@listening/assets/astro/icons/icon-menu.svg?react';
import * as m from '@/paraglide/messages';

import { useEffect, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

export function MobileNavCollapsible({
  children,
  onStateChange,
}: {
  children: React.ReactNode;
  onStateChange?: (isOpen: boolean) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const windowSize = useWindowSize();

  if (isOpen && windowSize.width > 768) setIsOpen(false);

  useEffect(() => {
    document.documentElement.classList.toggle('overflow-hidden', isOpen);
    onStateChange?.(isOpen);
  }, [isOpen, onStateChange]);

  return (
    <>
      <button
        aria-controls='mobile-menu'
        aria-expanded={isOpen}
        aria-label={m.nav_toggle_menu()}
        className='relative z-60 p-2 text-black transition-colors hover:text-black/80 md:hidden'
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        type='button'
      >
        {isOpen ? (
          <IconClose
            aria-hidden='true'
            className={cn('size-6 text-white sm:size-7')}
          />
        ) : (
          <IconMenu aria-hidden='true' className={cn('size-4 sm:size-7')} />
        )}
        <span className='sr-only'>
          {isOpen ? m.nav_close_menu() : m.nav_open_menu()}
        </span>
      </button>
      {isOpen && (
        <div
          aria-label={m.nav_aria_mobile_menu()}
          aria-modal='true'
          className='fixed inset-0 z-50 bg-black/80'
          id='mobile-menu'
          role='dialog'
        >
          {children}
        </div>
      )}
    </>
  );
}
